import { Modal } from '@rappi/rests-commons-front';
import styled from 'styled-components';
export const StyledBasicModal = styled(Modal) `
  max-width: ${({ $maxWidth }) => $maxWidth || 'initial'};
`;
